import axios from 'axios';
import sissconst from './sissconst';
import Vue from 'vue';
import { Toast, Loading } from "vant";
import { router } from '@/router/router';
import { routers } from '@/router';
import Util from "@/lib/utils";
Vue.use(Toast);
const CancelToken = axios.CancelToken;
declare global {
  interface Window {
    siss: any,
    cancel: any
  }
}
const ajax = axios.create({
  baseURL: sissconst.remoteServiceBaseUrl,
  timeout: 30000,
});

// tslint:disable-next-line:only-arrow-functions
ajax.interceptors.request.use(function (config) {
  if (!!window.siss.auth.getToken()) {
    config.headers.common.Authorization = 'Bearer ' + window.siss.auth.getToken();
  }
  if (!!window.siss.auth.getgrayscale && !!window.siss.auth.getgrayscale()) {
    config.headers.common['grayscale'] = window.siss.auth.getgrayscale();
  }
  config.cancelToken = new CancelToken((c) => {
    window.cancel = c;
  });
  config.headers.common['.AspNetCore.Culture'] = window.siss.utils.getCookieValue('siss.Localization.CultureName');
  // config.headers.common["siss.TenantId"]=window.siss.multiTenancy.getTenantIdCookie();
  // let enshopid = Util.siss.auth.getenshopid();
  // let shopinfo = localStorage[enshopid + "_shopinfo"]
  //     ? JSON.parse(localStorage[enshopid + "_shopinfo"])
  //     : {};
  // if (shopinfo) {
  //     if (shopinfo.shopid && shopinfo.shopid=='50000001') {
  //         config.baseURL = `${sissconst.remoteServiceBaseUrl}/${shopinfo.shopid}`
  //     }
  // }

  return config;
  // tslint:disable-next-line:only-arrow-functions
}, function (error) {

  return Promise.reject(error);
});
const vm = new Vue({});
ajax.interceptors.response.use((respon) => {
  return respon;
}, async (error) => {
  // tslint:disable-next-line:max-line-length
  if (!!error.response && error.response.status == 401) {
    //Toast.fail('授权失效，正在尝试登陆')
    const openid = siss.utils.getQueryString('openid') || siss.utils.getCookieValue('User_Ticket');
    const obj: any = { openid: openid, type: '2' }
    if (!openid) {
      return Promise.reject(error);
    }
    const rep = ajax.post('/api/TokenAuth/AuthenticateMobile', obj).then(rep => {
      const tokenExpireDate = new Date(new Date().getTime() + 1000 * rep.data.result.expireInSeconds);
      siss.auth.setToken(rep.data.result.accessToken, tokenExpireDate);
      // tslint:disable-next-line:max-line-length
      siss.utils.setCookieValue(sissconst.authorization.encrptedAuthTokenName, rep.data.result.encryptedAccessToken, tokenExpireDate, siss.sissPath);
      location.reload(false)
    });
    let param = await Util.buildLoginLog()
    console.log('param===', param)
    ajax.get('/minimall/statistics-service/log.gif', {params: param}).then(res => {
      console.log(res)
    })
    return Promise.reject(error);
  }
  if (!!error.response && !!error.response.data.error && error.response.data.error.code == 912) {
    return Promise.reject(error.response.data);
    //code:-1
    //自定义错误，用具体业务逻辑去处理
  } else if (!!error.response && !!error.response.data.error && !!error.response.data.error.message && error.response.data.error.details) {
    //vm.$dialog.alert({ title: error.response.data.error.message, message: error.response.data.error.details })
    Toast.fail(error.response.data.error.details);
  } else if (!!error.response && !!error.response.data.error && !!error.response.data.error.message) {
    // tslint:disable-next-line:max-line-length
    //vm.$dialog.alert({ title: window.siss.localization.localize("LoginFailed"), message: error.response.data.error.message })
    Toast.fail(error.response.data.error.message);
  } else if (!error.response) {
    // tslint:disable-next-line:max-line-length
    // if(error.code=="ECONNABORTED"){
    //     Toast.fail("连接超时，请稍后再试");
    // }else{
    //     //Toast.fail("程序异常，请稍后再试");
    // }
    //vm.$dialog.alert({ title: error.response.data.error.message, message: window.siss.localization.localize('UnknownError') })
  }
  // setTimeout(() => {
  //    vm.$dialog.close();
  // },1000);
  // return Promise.reject(error);
});


export default ajax;
